import { createPinia } from 'pinia';

const pinia = createPinia()

export default pinia;

export * from './intake';
// export * from './scholarship';
export * from './interest-programme';
